module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gD9iu"))).then(() => parcelRequire('d0iPb'));